export default __webpack_public_path__ + "static/media/bx-play-circle.d3b942e5.svg";